// @ts-nocheck
import { getCurrentInstance } from 'vue'
import { useToastStore } from '@modules/shared/stores/toast'

// Store the Vue instance globally for helper functions
let globalVueInstance = null

// Function to set the global Vue instance (should be called from component setup)
export function setGlobalVueInstance() {
  globalVueInstance = getCurrentInstance()
}

// Function to get the global Vue instance safely
export function getGlobalVueInstance() {
  return globalVueInstance
}

// Helper function to access Vue's global properties safely
export function getVueGlobalProperty(propertyName) {
  if (globalVueInstance?.appContext?.config?.globalProperties) {
    return globalVueInstance.appContext.config.globalProperties[propertyName]
  }
  return null
}

// Specific helpers for commonly used global properties
export function getVueCookies() {
  return getVueGlobalProperty('$cookies')
}

export function getVueStore() {
  return getVueGlobalProperty('$appStore')
}

export function getVueRouter() {
  return getVueGlobalProperty('$router')
}

export function getVueError() {
  return getVueGlobalProperty('$error')
}

export function getVueMoment() {
  return getVueGlobalProperty('$moment')
}

// Strip HTML tags so the toast renders plain text only.
// Some BE error paths (e.g. providerErrors) historically pass HTML strings.
function stripHtml(input) {
  if (!input) return ''
  return String(input)
    .replace(/<\s*br\s*\/?\s*>/gi, '\n')
    .replace(/<\s*\/(div|p|li)\s*>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\n{2,}/g, '\n')
    .trim()
}

// Show a backend error to the user.
// - Default path: text-only toast (no error code, no x-trace-id).
// - Session-expired path: keep the legacy modal — its Ok button drives logout + redirect.
export async function callVueError(message, type = '', isHtml = false, isExpired = false) {
  if (isExpired) {
    const errorMethod = getVueError()
    if (errorMethod) {
      await errorMethod(message, type, isHtml, isExpired)
    } else {
      console.error('Vue $error method not available:', message)
    }
    return
  }

  const text = isHtml ? stripHtml(message) : (message ?? '').toString()
  if (!text) return

  try {
    useToastStore().error(text)
  } catch (e) {
    console.error('Toast store not ready, error was:', text, e)
  }
}

// Function to safely access cookies
export function getCookie(name) {
  const cookies = getVueCookies()
  return cookies ? cookies.get(name) : null
}

export function setCookie(name, value, expires) {
  const cookies = getVueCookies()
  if (cookies) {
    cookies.set(name, value, expires)
  }
}

export function removeCookie(name) {
  const cookies = getVueCookies()
  if (cookies) {
    cookies.remove(name)
  }
}
